'use client'

import { Button } from '@/General/Button'
import Link from 'next/link'
import { RssIcon } from '@heroicons/react/24/outline'
import { H1 } from '@/General/H1'
import { useRouter } from 'next/navigation'
import { useState } from 'react'

export const BlogHeader = ({ title, pageNumber }: BlogHeaderProps) => {
  const router = useRouter()
  const [searchTerm, setSearchTerm] = useState('')

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault()
    if (searchTerm.trim()) {
      router.push(`/blog/search?query=${encodeURIComponent(searchTerm.trim())}`)
    }
  }

  return (
    <div className="flex flex-col lg:flex-row lg:items-center lg:justify-between gap-4">
      <H1 className="mb-0 text-4xl">
        {title}
        {pageNumber && pageNumber > 1 && (
          <span className="text-gray-500"> - page {pageNumber}</span>
        )}
      </H1>
      <form onSubmit={handleSearch} className="flex items-center gap-2">
        <input
          type="text"
          placeholder="Blog search"
          value={searchTerm}
          onChange={e => setSearchTerm(e.target.value)}
          className="border border-gray-300 rounded-md p-2 flex-1 lg:min-w-80"
        />
        <Button type="submit" color="amber" className="min-w-30">
          Search
        </Button>
        <Link
          href="/blog/rss"
          className="p-2 border border-gray-300 rounded-md text-gray-600 hover:text-vi-red hover:border-vi-red transition-colors"
          title="RSS Feed"
        >
          <RssIcon className="h-5 w-5" />
        </Link>
      </form>
    </div>
  )
}

interface BlogHeaderProps {
  title: string
  pageNumber?: number
}
